/**
 * @file        src/components/FullScreenButton.jsx
 * @description The Details drawers' full-screen button: opens the same booking
 *              details as their own page (/<product>/bookings/:id/details) in a
 *              new tab. Carries the B2C / Corporate origin via docPath(), so the
 *              page's sidebar and Close land on the right list.
 * @author      Kinetika Labs
 * @created     2026-10-09
 * @changelog
 *   - 2026-10-09 Claude — Initial.
 */
import Icon from './Icon';
import { docPath } from '../lib/docOrigin';

// The router's basename (main.jsx) — window.open takes a real URL, not a route.
const BASENAME = '/admin';

export default function FullScreenButton({ product, bookingId, audience }) {
  const open = () => window.open(
    `${BASENAME}${docPath(`/${product}/bookings/${bookingId}/details`, audience)}`,
    '_blank',
    'noopener',
  );
  return (
    <button type="button" className="ib" aria-label="Open full screen" title="Open full screen in a new page" onClick={open}>
      <Icon name="expand" />
    </button>
  );
}
